;(function () {
  angular
    .module('contrast.servers')
    .controller('ServerDashboardCtrl', ServerDashboardCtrl)

  function ServerDashboardCtrl(
    $scope,
    $rootScope,
    $routeParams,
    $uibModal,
    $location,
    $q,
    $translate,
    ErrorService,
    FeaturesService,
    UserService,
    serverConfirmAndApplyProtectLicenseService,
    LicenseService,
    LibrariesStatsVisibilityService,
    currentServerService,
    ServerService,
    LanguagesService,
    ServerFactory,
    TagFactory,
    AGENT_FEATURE,
    SERVER_ENVIRONMENT_LIST,
    SERVER_EVENTS,
    CURRENT_SERVER_EVENTS,
    permissions
  ) {
    'ngInject'

    var _getServerOptions = { buildDotNet: true },
      _deregisterCurrentServerOnChange

    angular.extend($scope, {
      serverId: $routeParams.serverId,
      server: {},
      loaded: false,
      loadServerPromise: false,
      model: {
        statsVisible: LibrariesStatsVisibilityService.model,
        statsLoaded: false
      },
      protection: {
        breakdown: {
          total: 0,
          unused: 0,
          used: 0
        }
      },
      isAssessLanguageSupported: false,
      isProtectLanguageSupported: false,
      isProxyServer: false,
      sampleId: UserService.getSampleServerID(),
      libraries_stats: {},
      libraries_vulns: null,
      isServerSettingsDialogOpen: false
    })

    angular.extend($scope, {
      deleteTag: deleteTag,
      tagServer: tagServer,
      deleteServer: deleteServer,
      updateDisplayName: updateDisplayName,
      getEmptyStateConfigKey: getEmptyStateConfigKey,
      showNotes: showNotes,
      launchSingleApplyProtectionDialog: launchSingleApplyProtectionDialog,
      isNotProtectionLicensesAvailable:
        ServerService.isNotProtectionLicensesAvailable,
      isServerProtectionInvalidLanguage:
        ServerService.isServerProtectionInvalidLanguage,
      isServerProtectionValid: ServerService.isServerProtectionValid,
      isSampleServer: isSampleServer,
      getStats: getStats,
      setStatsLoaded: setStatsLoaded,
      saveServerSettingsCallback,
      showServerSettingsDialog,
      closeServerSettingsDialog,
      getAgentFeatures,
      isServerSettingsReadOnly
    })

    function launchSingleApplyProtectionDialog(server, updateProtection) {
      serverConfirmAndApplyProtectLicenseService
        .applyLicense([server], updateProtection)
        .then(loadProtectionLicenseBreakdown)
        .then(function () {
          $rootScope.$broadcast(CURRENT_SERVER_EVENTS.SERVER_CHANGE, server)
        })
    }

    function saveServerSettingsCallback() {
      loadServer().then(function () {
        $rootScope.$broadcast(SERVER_EVENTS.UPDATE_SERVER)
      })
    }

    function showServerSettingsDialog() {
      $scope.isServerSettingsDialogOpen = true
    }

    function closeServerSettingsDialog() {
      $scope.isServerSettingsDialogOpen = false
    }

    function getAgentFeatures() {
      return FeaturesService.getAll()
    }

    function isServerSettingsReadOnly() {
      return !permissions.hasPermission('EDIT')
    }

    function init() {
      $scope.loadServerPromise = false

      if (!_deregisterCurrentServerOnChange) {
        _deregisterCurrentServerOnChange = currentServerService.onChange(
          function (server) {
            $scope.server = server
          },
          _getServerOptions
        )
      }

      $scope.$on('$destroy', _destroy)

      loadServer().then(function () {
        $scope.loadServerPromise = true
        $scope.isAssessLanguageSupported =
          FeaturesService.isAgentFeatureEnabled(
            AGENT_FEATURE.ASSESS,
            $scope.server.language,
            true
          )
        $scope.isProtectLanguageSupported =
          FeaturesService.isAgentFeatureEnabled(
            AGENT_FEATURE.PROTECTION,
            $scope.server.language,
            true
          )
        $scope.isProxyServer = LanguagesService.isProxy($scope.server.language)
      })

      loadTags()

      if (
        permissions.isRASPEnabled() &&
        permissions.hasPermission('RULES_ADMIN')
      ) {
        loadProtectionLicenseBreakdown()
      }
    }

    function _destroy() {
      if (angular.isFunction(_deregisterCurrentServerOnChange)) {
        _deregisterCurrentServerOnChange()
      }
    }

    function loadProtectionLicenseBreakdown() {
      $scope.loadProtectionLicenseBreakdownPromise = false
      return LicenseService.getProtectionBreakdown().then(function (breakdown) {
        $scope.protection.breakdown = breakdown
        $scope.loadProtectionLicenseBreakdownPromise = true
      })
    }

    function getEmptyStateConfigKey() {
      if ($scope.server.defend) {
        return 'serverAttacks'
      }
      return 'serverAttacksNoProtect'
    }

    function deleteTag(data) {
      TagFactory.deleteServerTags($scope.serverId, data).then(function (
        response
      ) {
        $scope.tags = response.data.tags
      },
      ErrorService.processError)
    }

    function tagServer() {
      var transl = {
        title_serverDashboard_tagServer: $translate.instant(
          'title_serverDashboard_tagServer'
        )
      }

      var modalInstance
      modalInstance = $uibModal.open({
        templateUrl: 'views/tags/modal_tag.html',
        controller: 'ModalTagServersCtrl',
        size: 'full',
        resolve: {
          servers: function () {
            return [$scope.server]
          },
          title: function () {
            return transl.title_serverDashboard_tagServer
          }
        }
      })

      modalInstance.result.then(function () {
        init()
      })
    }

    function deleteServer() {
      ServerFactory.getAppTraces($scope.serverId).then(function (response) {
        var orphansdata = response.data.applications
        var modalInstance
        modalInstance = $uibModal.open({
          templateUrl: 'views/servers/modal_delete.html',
          controller: 'ModalDeleteInstanceCtrl',
          size: orphansdata.length > 0 ? 'md' : 'sm',
          resolve: {
            appTraces: function () {
              return orphansdata
            },
            server: function () {
              return $scope.server
            },
            orgUuid: function () {
              return $routeParams.orgUuid
            }
          }
        })
        modalInstance.result.then(function () {
          $location.path(UserService.buildUrl('/servers'))
        })
      }, ErrorService.processError)
    }

    function updateDisplayName(data) {
      if ($scope.server.name != data && data.length > 0) {
        return ServerFactory.updateName($scope.serverId, data).then(
          function () {
            $scope.server.name = data
          },
          ErrorService.processError
        )
      } else {
        return $q.reject()
      }
    }

    function loadServer() {
      return currentServerService
        .init($scope.serverId, _getServerOptions)
        .then(function (server) {
          $scope.server = server
          $scope.loaded = true

          var pendings = []
          if ($scope.server.defendPending) {
            pendings.push('Protection')
          }
          if ($scope.server.assessPending) {
            pendings.push('Assessment')
          }
          if ($scope.server.logEnhancerPending) {
            pendings.push('Log Enhancer')
          }

          $scope.server.pendings = pendings.join(', ')

          var env = _.find(SERVER_ENVIRONMENT_LIST, function (item) {
            return item.value === $scope.server.environment
          })

          $scope.server.environment = env.name
        })
        .catch(ErrorService.processError)
    }

    function loadTags() {
      return TagFactory.getServerTags($scope.serverId).then(function (
        response
      ) {
        $scope.tags = response.data.tags
      },
      ErrorService.processError)
    }

    function showNotes() {
      return LanguagesService.isDotnet($scope.server.language)
    }

    function isSampleServer() {
      return $scope.sampleId == $scope.serverId
    }

    function getStats() {
      if (!$scope.model.statsLoaded) {
        ServerFactory.getLibrariesStats($scope.serverId).then(function (
          response
        ) {
          var data = response.data
          $scope.libraries_stats = data.stats
          $scope.libraries_vulns = data.stats.total_vulnerabilities > 0
          setStatsLoaded(true)
        })
      }
    }

    function setStatsLoaded(isLoaded) {
      $scope.model.statsLoaded = isLoaded
    }

    init()
  }
})()
